export default __webpack_public_path__ + "static/media/roadmap-glow2.5cc460ed.png";